// contact requirements
export const contactInitialState = {
  reloadContactList: false,
};

export const contactReducer = (state, action) => {
  switch (action.type) {
    case "SET_RELOAD_CONTACT_LIST":
      return { ...state, reloadContactList: action.payload };
    default:
      return state;
  }
};
